import { loginApi } from "@/api/login";
import router from '@/router'
import { setTokenTime } from "@/utils/auth";
import { Message } from 'element-ui';// message
import { companyListApi } from "@/api/login";
export default {
  namespaced: true,
  state: () => ({
    resId: '',
    token: localStorage.getItem('token') || '',
    custID: localStorage.getItem('custID') || '',
    MemberManagementRightSelect: '',//会员管理模块(相关列表快速链接)选中的下标记录
    MemberInformation: JSON.parse(localStorage.getItem('MemberInformation')) || {},  //会员基础信息
    CouponsSelectChang: JSON.parse(localStorage.getItem('CouponsSelectChang')) || '',   //劵管理用户选择的行
    webpackge: JSON.parse(localStorage.getItem('webpackge')) || '',
  }),
  mutations: {
    couponstoview(state, data) {
      state.webpackge = data
    },
    SetCouponsSelectChang(state, data) {
      state.CouponsSelectChang = data
    },
    setToken(state, token) {
      state.token = token;
      localStorage.setItem('token', token)
    },
    clearToken(state, token) {
      state.token = token
      localStorage.removeItem("token");
    },
    //获取custid
    getcustID(state, value1) {
      state.custID = value1
    },
    GetMemberInformation(state, value) {
      state.MemberInformation = value
    },
    // 不要慌开发进度在掌握之中
    SetMemberManagementRightSelect(state, value) {
      state.MemberManagementRightSelect = value
    },
  },
  actions: {
    couponstoview(wx, val) {
      wx.commit('couponstoview', val)
    },
    USetCouponsSelectChang(ctx, value) {
      ctx.commit('SetCouponsSelectChang', value)
    },
    USetMemberManagementRightSelect(ctx, value) {
      ctx.commit('SetMemberManagementRightSelect', value)
    },
    UpGetMemberInformation(ctx, value) {
      ctx.commit('GetMemberInformation', value)
    },
    login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        loginApi(userInfo).then(res => {
          localStorage.setItem('tokenTime', Date.now())
          localStorage.setItem('token', res.access_token)
          commit('setToken', res.access_token);
          companyListApi().then((response) => {
            if (response.data.length == 1) {
              localStorage.setItem("cpyNo", response.data[0].cpyNO);
              if("6100"==response.data[0].cpyNO){
                localStorage.setItem("cpyName", "GIADA");
              }else if("6300"==response.data[0].cpyNO){
                localStorage.setItem("cpyName", "CURIEL");
              }
            }
            if (localStorage.getItem("cpyNo")) {
              setTokenTime()
              router.replace("/Layout")
              resolve()
            } else {
              localStorage.setItem('tokenTime', Date.now())
              localStorage.setItem('token', res.access_token)
              resolve(false)
            }
          });


        }).catch(error => {
          Message.error("账号或密码错误!");
          reject(error)
        })
      })
    },
    getcompanyListApi() {
      companyListApi().then((res) => {
        if (res.data.length == 1) {
          localStorage.setItem("cpyNo", res.data.cpyNO);
          return true
        }
        return res.data.length > 1 ? false : true;
      });
    },
    //  logout({commit}){
    //     return new Promise((resolve,reject)=>{
    //         logoutApi().then(res=>{
    //             commit('clearToken',res.access_token);
    //             // localStorage.clear();
    //             router.replace('/')
    //             resolve()
    //         }).catch(err=>{
    //             reject(err)
    //         })
    //     })
    //  }
    // 退出登录清除token
    logout({ commit }) {
      commit('clearToken', '');
      router.replace('/')
    }
  }
}
